import Vue from 'vue'
import App from './views/App.vue'
import axios from 'axios';
import store from './store';
import router from './router'
import ClickOutside from 'vue-click-outside'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueGtag from "vue-gtag";

import './assets/stylesheets/bootstrap.min.css'
import './assets/stylesheets/style.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faLinkedinIn, faTwitter, faFacebookSquare } from '@fortawesome/free-brands-svg-icons'

import {
  faUserSecret,
  faDollarSign,
  faShoppingCart,
  faGlobe,
  faUsers,
  faMapMarkerAlt,
  faCheckCircle,
  faTags,
  faPlus,
  faFileCsv,
  faFilePdf,
  faAddressBook,
  faUser,
  faCog,
  faQuestionCircle,
  faSignOutAlt,
  faTrash,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret, faDollarSign, faShoppingCart, faGlobe, faUsers, faMapMarkerAlt, faLinkedinIn, faTwitter, faFacebookSquare, faCheckCircle, faTags, faPlus, faFileCsv,faFilePdf, faAddressBook, faUser, faCog, faQuestionCircle, faSignOutAlt, faTrash, faInfoCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import BootstrapVue from 'bootstrap-vue'
import Notifications from 'vue-notification'
import ArrayHelper from './helpers/array'
import StringHelper from './helpers/string'
import DateHelper from './helpers/date'
import FileHelper from './helpers/file'
import LogoHelper from './helpers/logo'
import Defaults from './defaults/defaults'
import Constants from './defaults/constants'

const token = localStorage.getItem('token')

Vue.prototype.$api = axios
Vue.prototype.$api.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

Vue.prototype.arrayHelper = ArrayHelper
Vue.prototype.stringHelper = StringHelper
Vue.prototype.dateHelper = DateHelper
Vue.prototype.fileHelper = FileHelper
Vue.prototype.LogoHelper = LogoHelper

Vue.prototype.defaults = Defaults
Vue.prototype.constants = Constants
Vue.prototype.apiKeys =
    {
        tinyMCE: process.env.VUE_APP_TINYMCE_API_KEY
    }

Vue.use(BootstrapVue)
Vue.use(Notifications)

Vue.directive('click-outside', ClickOutside)

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY})
Vue.use(VueGtag, {config: {id: process.env.VUE_APP_GOOGLE_TAG_ID}}, router)

Vue.prototype.$api.interceptors.response.use((response) => response, (error) => {

    if (typeof error.response !== "undefined") {
        if (error.response.status == 500) {
            alert('Server error occured')
        }

        if (error.response.status == 401) {
            store.commit('setNeedLogout', true)
        }

        if (error.response.status == 404) {
            store.commit('setPageNotFound', true)
        }

        if (process.env.NODE_ENV == 'development') {
            console.log(error.response.data)
        }
    }
    throw error;
});

Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})

Vue.config.ignoredElements = ['qrvey-end-user','qrvey-builders']

//localStorage.removeItem('token')

if (token) {
    Vue.prototype.$api.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')